import React from "react";
// افترض انك بتستخدم مكتبة ايقونات زي react-icons او fontawesome
// npm install react-icons
import { FaCalendarAlt, FaChevronRight } from "react-icons/fa"; 
import "../assets/styles/AdminRequests.css"; // استدعاء ملف الـ CSS

const RequestSummaryCard = ({ data, onViewDetails }) => {
  // data هنا هي الـ object اللي راجع من الـ API (requester, summary, createdAt)
  
  return (
    <div className="summary-card p-3 mb-3 d-flex align-items-center flex-wrap gap-3">
      {/* 1. صورة الشخص */}
      <div className="flex-shrink-0">
        <img
          src={data.requester.avatar || "https://via.placeholder.com/150"} // صورة افتراضية لو مفيش
          alt={data.requester.name}
          className="avatar-circle"
        />
      </div>

      {/* 2. تفاصيل الطلب (في النص) */}
      <div className="flex-grow-1">
        <h6 className="mb-1 fw-bold text-dark">{data.summary.title}</h6>
        <p className="mb-1 text-muted small">{data.summary.subtitle}</p>
        <div className="d-flex align-items-center gap-2 req-date">
          <FaCalendarAlt size={12} />
          <span>{new Date(data.createdAt).toLocaleDateString()}</span>
          <span className="text-secondary ms-2 small">• By {data.requester.name}</span>
        </div>
      </div>

      {/* 3. زر التفاصيل (في اليمين) */}
      <div className="ms-auto">
        <button 
          className="btn-details d-flex align-items-center gap-2"
          onClick={() => onViewDetails(data._id)}
        >
          View Details <FaChevronRight size={12} />
        </button>
      </div>
    </div>
  );
};

export default RequestSummaryCard;
